import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system"

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(["td"])

export const tableTheme = defineMultiStyleConfig({
  baseStyle: props => {
    return {
      table: {
        pl: 2,
        pr: 2,
        pb: 4,
        bg: props.colorMode === "light" ? "white" : "gray.900",
        color: props.colorMode === "light" ? "gray.900" : "white",
        lineHeight: 1.4,
      },
      th: {
        px: 3,
        pr: 3,
        pl: 3,
        color: props.colorMode === "light" ? "white" : "white",
        bg: props.colorMode === "light" ? "white" : "gray.900",
      },
      tr: {
        _hover: {
          bg: props.colorMode === "light" ? "gray.50" : "whiteAlpha.200",
        },
      },
      td: {
        py: 4,
        px: 3,
        pr: 3,
        pl: 3,
        lineHeight: 1.4,
      },
    }
  },
})
